import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { UserConfigurationService } from '../../../../core/services/user-configuration.service';
import { Timezone } from '../../../../shared/contract/timezone.contract';

@Injectable({ providedIn: 'root' })
export class TimezoneService {
  private userConfigurationService = inject(UserConfigurationService);
  private http = inject(HttpClient);

  private url: string = environment.APP_USERROLE_SERVICE_BASE_URL + '/api/v1/users/available-timezones';

  public getTimezones(filterTerm: string): Observable<Timezone[]> {
    return this.http.get<Timezone[]>(`${this.url}`, { params: { filterTerm } });
  }

  public getUserTimezone(): string {
    return this.userConfigurationService.getUserTimezone();
  }

  public setUserTimezone(timezone: string): Observable<unknown> {
    return this.userConfigurationService.saveUserTimezone(timezone);
  }

}
